import React, { useState } from 'react';

const Counter = () => {
    const [counters, setCounters] = useState([1, 1, 1, 1, 1]);

    const arr = [
        {
            "name": "ab",
            "price": 10
        },
        {
            "name": "ab1",
            "price": 20
        },
        {
            "name": "ab2",
            "price": 30
        },
        {
            "name": "ab3",
            "price": 40
        },
        {
            "name": "ab4",
            "price": 50
        },
        {
            "name": "ab4",
            "price": 60
        },
        {
            "name": "ab4",
            "price": 60
        },
    ];

    const increment = (index) => {
        console.log(index)
        console.log(counters)
        const newCounters = [...counters];
        newCounters[index] += 1;
        setCounters(newCounters);
    };

    const decrement = (index) => {
        console.log(index)
        console.log(counters)
        if (counters[index] > 0) {
            const newCounters = [...counters];
            newCounters[index] -= 1;
            setCounters(newCounters);
        }
    };

    return (
        <div className='row'>
            {arr.map((items, index) => {
                const totalPrice = items.price * counters[index]; // Calculate the total price for each item
                return (
                    <div className='col-sm-4' key={index}>
                        <div className='card'>
                            <div className='card-header text-center'>
                                <h3>name {items.name}</h3>
                                <p>price {totalPrice}</p> {/* Display the calculated total price */}
                            </div>
                            <div className='card-body'>
                                <button className='btn btn-success ml-5' onClick={() => increment(index)}>increment</button>
                                <h4 className='ml-5'>{counters[index]}</h4>
                                <button className='btn btn-danger ml-5' onClick={() => decrement(index)}>decrement</button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Counter;
